import SimpleModal from 'components/global/SimpleModal';
import UniversalInput from 'components/global/UniversalInput';
import { handleHideModal } from 'components/global/_helpers/global.helpers';
import { handleCreateFolder, handleSubmitDocumentEditSubmit } from 'components/views/FounderVault/_helpers/founderVault.events';
import { $form, $view } from 'signals/global.signals';
import getSelectValue from 'utils/getSelectValue';

const FounderFolderCreateModal = () => (
  <SimpleModal
    show={$view.value?.activeModal === 'founder-folder-create'}
    isLoading={$view.value?.isModalLoading}
    title={`Create new folder`}
    onHide={handleHideModal}
    onPrimaryClick={handleCreateFolder}
    primaryButtonText="Save"
    secondaryButtonText="Cancel"
    onSecondaryClick={handleHideModal}
  >
    <UniversalInput
      label="File Name"
      name="name"
      type="text"
      placeholder="Enter name"
      className="mb-16"
    />
  </SimpleModal>
);

export default FounderFolderCreateModal;
